<script>
export default {
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    subMenuAvailable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      submenuStyles: {},
    };
  },
  methods: {
    handleMouseEnter(event) {
      if (!this.subMenuAvailable) return;
      
      // Get the submenu element
      const submenu = this.$el.querySelector('.submenu');
      if (!submenu) return;
      
      // Calculate available space
      const menuRect = this.$el.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - menuRect.bottom;
      const submenuHeight = Math.min(submenu.scrollHeight, 300); // Max height 300px (or custom value)
      
      // Determine if submenu would extend beyond viewport bottom
      if (spaceBelow < submenuHeight) {
        // Not enough space below, position relative to bottom edge
        const bottomOffset = Math.min(submenuHeight, menuRect.top);
        this.submenuStyles = {
          top: 'auto',
          bottom: '0',
          maxHeight: `${Math.min(submenuHeight, viewportHeight - 20)}px`, // Leave some margin
        };
      } else {
        // Enough space below, use default positioning
        this.submenuStyles = {
          top: '0',
          bottom: 'auto',
          maxHeight: `${Math.min(submenuHeight, spaceBelow - 10)}px`, // Leave some margin
        };
      }
    },
  },
};
</script>

<template>
  <div
    class="text-slate-800 dark:text-slate-100 menu-with-submenu min-width-calc w-full p-1 flex items-center h-7 rounded-md relative bg-n-alpha-3/50 backdrop-blur-[100px] justify-between hover:bg-n-brand/10 cursor-pointer dark:hover:bg-n-solid-3"
    :class="!subMenuAvailable ? 'opacity-50 cursor-not-allowed' : ''"
    @mouseenter="handleMouseEnter"
  >
    <div class="flex items-center h-4">
      <fluent-icon :icon="option.icon" size="14" class="menu-icon" />
      <p class="my-0 mx-2 text-xs">{{ option.label }}</p>
    </div>
    <fluent-icon icon="chevron-right" size="12" />
    <div
      v-if="subMenuAvailable"
      class="submenu bg-n-alpha-3 backdrop-blur-[100px] p-1 shadow-lg rounded-md absolute left-full top-0 hidden overflow-y-auto overflow-x-hidden cursor-pointer"
      :style="submenuStyles"
    >
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.menu-with-submenu {
  min-width: calc(6.25rem * 2);

  &:hover {
    .submenu {
      @apply block;
    }
  }
}

.submenu {
  max-height: 300px;
  overflow-y: auto;
  z-index: 100;
}
</style>
